import { style } from '@do/walrus';
import React, { ReactElement } from 'react';
import { SplashVariant } from '../interfaces/variant';
import { Column, WrapSplit } from './Common';
import SplashSplit from './SplashSplit';

interface Props {
  variant: SplashVariant;
}

export const Splash: React.FC<Props> = ({ variant }): ReactElement => (
  <Column
    style={{
      backgroundImage: `${
        variant.background.image
          ? `url(${variant.background.image})`
          : undefined
      }`,
      backgroundPosition: `${variant.background.horizontalPosition ??
        'center'} ${variant.background.verticalPosition ?? 'center'}`,
      backgroundColor: style.colors.primaryBackground,
      backgroundSize: 'cover'
    }}
  >
    <WrapSplit>
      {(variant.image || variant.title) && <SplashSplit variant={variant} />}
    </WrapSplit>
  </Column>
);
